import { h } from 'preact'
import { isEmptyObject } from '../../js/modules/utilities'

export const SecondContract = ({ title, pill, mobileCard, contractCard, CTA, DROText }) => {
   return (
      <div class="container-fluid">
         <div class="row mb-3 mt-2 seconde-ligne" id="parcours-marchands-seconde-ligne" data-testid="bande-seconde-ligne">
            <div class="col-12">
               <div class="cadre-seconde-ligne pb-md-1">
                  <div class="title-placeholder w-100">
                     <h3 class="seconde-ligne-title">{title}</h3>
                  </div>
                  <ul class="items-list row m-0">
                     <li class="col-12 col-xl-5 mb-md-1 px-xs-only-0">
                        <span class="ob1-capsule ob1-capsule-context ml-md-1 mt-1">{pill}</span>
                        {DROText !== '' ? (
                           <p class="alert alert-info" role="alert">
                              <span class="alert-icon" aria-hidden="true"></span>
                              <span class="ob1-alert-title">{DROText}</span>
                           </p>
                        ) : (
                           ''
                        )}
                     </li>
                     <li class="col-12 col-md-6 col-xl-3 px-xs-only-0">
                        <a
                           href={mobileCard.URL}
                           class="items-list-item"
                           data-testid="second_contrat1"
                           data-pdb-zid={mobileCard.analytics.pdbZid}
                           data-pdb-sc={mobileCard.analytics.pdbSc}
                           data-pdb-idc={mobileCard.analytics.pdbIdc}
                           data-oevent-category={mobileCard.analytics.oeventCategory}
                           data-oevent-action={mobileCard.analytics.oeventAction}
                           data-oevent-label={mobileCard.analytics.oeventLabel}
                           data-oevent-other={mobileCard.analytics.oeventOther}
                        >
                           <span class="item-icon icon-device-smart-phone" aria-hidden="true"></span>
                           <div class="item-container">
                              <div class="item-text">
                                 <span class="item-title">{mobileCard.title}</span>
                                 <small class="item-desc">{mobileCard.description}</small>
                              </div>
                           </div>
                        </a>
                     </li>
                     <li class="col-12 col-md-6 col-xl-3 px-xs-only-0">
                        <a
                           href={contractCard.URL}
                           class="items-list-item"
                           data-testid="second_contrat2"
                           data-pdb-zid={contractCard.analytics.pdbZid}
                           data-pdb-sc={contractCard.analytics.pdbSc}
                           data-pdb-idc={contractCard.analytics.pdbIdc}
                           data-oevent-category={contractCard.analytics.oeventCategory}
                           data-oevent-action={contractCard.analytics.oeventAction}
                           data-oevent-label={contractCard.analytics.oeventLabel}
                           data-oevent-other={contractCard.analytics.oeventOther}
                        >
                           <span class="item-icon icon-sim" aria-hidden="true"></span>
                           <div class="item-container">
                              <div class="item-text">
                                 <span class="item-title">{contractCard.title}</span>
                                 <small class="item-desc">{contractCard.description}</small>
                              </div>
                           </div>
                        </a>
                     </li>
                  </ul>
               </div>

               {!isEmptyObject(CTA) ? (
                  <div class="col-12 mt-1 mt-md-2 d-flex justify-content-center">
                     <a
                        href={CTA.URL}
                        class="btn btn-secondary"
                        data-testid="second_contratCTA"
                        data-pdb-zid={CTA.analytics.pdbZid}
                        data-pdb-sc={CTA.analytics.pdbSc}
                        data-pdb-idc={CTA.analytics.pdbIdc}
                        data-oevent-category={CTA.analytics.oeventCategory}
                        data-oevent-action={CTA.analytics.oeventAction}
                        data-oevent-label={CTA.analytics.oeventLabel}
                        data-oevent-other={CTA.analytics.oeventOther}
                     >
                        {CTA.label}
                     </a>
                  </div>
               ) : (
                  ''
               )}
            </div>
         </div>
      </div>
   )
}
